<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>About Us - Suncrest Global</title>

  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">

  <style>
    *{
      margin:0;
      padding:0;
      box-sizing:border-box;
    }

    body{
      font-family:'Poppins',sans-serif;
      background:#f4f7fb;
      color:#222;
      overflow-x:hidden;
    }

    a{
      text-decoration:none;
    }

    /* HERO SECTION */

    .hero{
      width:100%;
      min-height:100vh;
      background:
      linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)),
      url('https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1500&q=80');
      background-size:cover;
      background-position:center;
      display:flex;
      align-items:center;
      justify-content:center;
      text-align:center;
      padding:40px;
      position:relative;
    }

    .hero-content{
      max-width:900px;
      color:#fff;
      animation:fadeIn 1.5s ease;
    }

    .hero-content h1{
      font-size:65px;
      margin-bottom:20px;
      font-weight:700;
      line-height:1.2;
    }

    .hero-content span{
      color:#ffcc00;
    }

    .hero-content p{
      font-size:20px;
      line-height:1.8;
      margin-bottom:35px;
      color:#f1f1f1;
    }

    .hero-btn{
      display:inline-block;
      padding:16px 40px;
      background:linear-gradient(45deg,#ff9800,#ff5722);
      color:#fff;
      border-radius:50px;
      font-size:18px;
      font-weight:600;
      transition:0.4s;
      box-shadow:0 10px 25px rgba(0,0,0,0.25);
    }

    .hero-btn:hover{
      transform:translateY(-5px);
      background:linear-gradient(45deg,#00c853,#009688);
    }

    /* ABOUT SECTION */

    .about-section{
      padding:100px 8%;
      background:#fff;
    }

    .section-title{
      text-align:center;
      margin-bottom:70px;
    }

    .section-title h2{
      font-size:45px;
      color:#1f2937;
      margin-bottom:15px;
      position:relative;
      display:inline-block;
    }

    .section-title h2::after{
      content:'';
      width:70px;
      height:5px;
      background:#ff9800;
      position:absolute;
      left:50%;
      bottom:-15px;
      transform:translateX(-50%);
      border-radius:10px;
    }

    .section-title p{
      max-width:700px;
      margin:auto;
      color:#666;
      font-size:18px;
      line-height:1.8;
      margin-top:30px;
    }

    .about-container{
      display:grid;
      grid-template-columns:repeat(auto-fit,minmax(350px,1fr));
      gap:50px;
      align-items:center;
    }

    .about-image img{
      width:100%;
      border-radius:25px;
      box-shadow:0 20px 40px rgba(0,0,0,0.15);
      transition:0.5s;
    }

    .about-image img:hover{
      transform:scale(1.03);
    }

    .about-content h3{
      font-size:38px;
      margin-bottom:20px;
      color:#0f172a;
    }

    .about-content p{
      font-size:17px;
      color:#555;
      line-height:1.9;
      margin-bottom:20px;
    }

    .highlight{
      color:#ff5722;
      font-weight:600;
    }

    /* FEATURES */

    .features{
      padding:100px 8%;
      background:linear-gradient(135deg,#0f172a,#1e293b);
    }

    .features-grid{
      display:grid;
      grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
      gap:30px;
      margin-top:50px;
    }

    .feature-card{
      background:#fff;
      padding:40px 30px;
      border-radius:25px;
      text-align:center;
      transition:0.4s;
      box-shadow:0 15px 30px rgba(0,0,0,0.1);
    }

    .feature-card:hover{
      transform:translateY(-12px);
    }

    .feature-icon{
      font-size:55px;
      margin-bottom:20px;
    }

    .feature-card h3{
      margin-bottom:15px;
      font-size:24px;
      color:#111827;
    }

    .feature-card p{
      color:#666;
      line-height:1.7;
    }

    /* MISSION SECTION */

    .mission{
      padding:100px 8%;
      background:#f8fafc;
    }

    .mission-box{
      background:linear-gradient(135deg,#ff9800,#ff5722);
      border-radius:30px;
      padding:70px 50px;
      text-align:center;
      color:#fff;
      box-shadow:0 20px 50px rgba(0,0,0,0.15);
    }

    .mission-box h2{
      font-size:48px;
      margin-bottom:25px;
    }

    .mission-box p{
      font-size:20px;
      line-height:1.9;
      max-width:900px;
      margin:auto;
    }

    /* FOOTER */

    footer{
      background:#0f172a;
      color:#fff;
      padding:30px;
      text-align:center;
      font-size:16px;
    }

    /* ANIMATION */

    @keyframes fadeIn{
      from{
        opacity:0;
        transform:translateY(30px);
      }
      to{
        opacity:1;
        transform:translateY(0);
      }
    }

    /* RESPONSIVE */

    @media(max-width:768px){

      .hero-content h1{
        font-size:42px;
      }

      .hero-content p{
        font-size:17px;
      }

      .about-content h3{
        font-size:30px;
      }

      .section-title h2{
        font-size:36px;
      }

      .mission-box h2{
        font-size:35px;
      }

      .mission-box p{
        font-size:18px;
      }
    }

  </style>
</head>

<body>

  <!-- HERO -->

  <section class="hero">
    <div class="hero-content">
      <h1>Welcome to <span>Suncrest Global</span></h1>

      <p>
        Delivering premium organic spices, herbal products, and chemical-free
        agricultural goods to the global market with trust, quality, and sustainability.
      </p>

      <a href="#" class="hero-btn">Explore More</a>
    </div>
  </section>

  <!-- ABOUT -->

  <section class="about-section">

    <div class="section-title">
      <h2>About Us</h2>

      <p>
        We are committed to creating a healthier and disease-free world by delivering
        naturally grown organic products with international quality standards.
      </p>
    </div>

    <div class="about-container">

      <div class="about-image">
        <!-- <img src="https://images.unsplash.com/photo-1615485290382-441e4d049cb5?auto=format&fit=crop&w=1000&q=80" alt="Organic Products"> -->
        <img src="../../../assets/aerial-view-cargo-ship-cargo-container.jpg"
                alt="Suncrest Global Premium Seal" height="300" width="500" class="header-image-logo">
            <span class="online-dot"></span>
      </div>

      <div class="about-content">

        <h3>Who We Are</h3>

        <p>
          <span class="highlight">Suncrest Global</span> is a modern export-focused company
          dedicated to delivering high-quality organic spices, herbal products,
          and agricultural goods worldwide.
        </p>

        <p>
          Our mission is to bridge the gap between farmers and global consumers
          by ensuring purity, freshness, and sustainability in every product we export.
        </p>

        <p>
          We believe that healthy food creates a healthy future. That's why our products
          are carefully sourced, hygienically processed, and globally certified.
        </p>

      </div>

    </div>

  </section>

  <!-- FEATURES -->

  <section class="features">

    <div class="section-title">
      <h2 style="color:white;">Why Choose Us</h2>

      <p style="color:#cbd5e1;">
        We focus on quality, trust, and customer satisfaction for international markets.
      </p>
    </div>

    <div class="features-grid">

      <div class="feature-card">
        <div class="feature-icon">🌿</div>
        <h3>100% Organic</h3>
        <p>
          Chemical-free and naturally processed premium quality products.
        </p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">🚢</div>
        <h3>Global Export</h3>
        <p>
          Reliable worldwide export with safe packaging and fast delivery.
        </p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">⭐</div>
        <h3>Premium Quality</h3>
        <p>
          Strict quality checks ensure international-grade products.
        </p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">🤝</div>
        <h3>Trusted Partner</h3>
        <p>
          Building long-term relationships through transparency and commitment.
        </p>
      </div>

    </div>

  </section>

  <!-- MISSION -->

  <section class="mission">

    <div class="mission-box">

      <h2>Our Mission</h2>

      <p>
        “To deliver chemical-free and pesticide-free organic products to the global market
        while creating a healthier, sustainable, and disease-free world for future generations.”
      </p>

    </div>

  </section>

  <!-- FOOTER -->

  <footer>
    © 2026 Suncrest Global | All Rights Reserved
  </footer>

</body>
</html>